import React from 'react';
import SearchableSelect from '../../../components/ui/SearchableSelect/SearchableSelect';
import { SELECT_MODE } from '../../../components/ui/SearchableSelect/constants';
import useInterveneSx from '../hooks/useInterveneSx';
import { mergeSlotProps } from '../../../components/ui/SearchableSelect/selectUtils';

export default function InterveneSearchField({
  sx,
  spaced = false,
  slotProps,
  size = 'small',
  compact = false,
  mode = SELECT_MODE.STATIC,
  ...props
}) {
  const interveneSx = useInterveneSx();
  const searchStyles = compact
    ? interveneSx.dialog.searchField
    : interveneSx.searchField;

  const dropdownSlotProps = interveneSx.searchField?.slotProps;

  return (
    <SearchableSelect
      {...props}
      mode={mode}
      size={size}
      sx={{
        ...searchStyles.root,
        ...(spaced ? searchStyles.spaced : null),
        ...sx,
      }}
      slotProps={mergeSlotProps(
        dropdownSlotProps,
        slotProps
      )}
    />
  );
}